import { createClient } from "@supabase/supabase-js";

// Client-side Supabase connection. Uses the publishable key only —
// never a service_role/secret key. Values come from REACT_APP_ env vars.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabasePublishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
